import {
    ORDER_ARTICLE_FORM_SUBMIT,
    ORDER_ARTICLE_FORM_SUBMIT_DONE,
    ORDER_ARTICLE_FORM_SUBMIT_ERROR,
    ORDER_ARTICLE_FORM_SET_ORDER_ARTICLE_FORM_DETAILS,
    ORDER_ARTICLE_FORM_SET_FILE_NAMES
} from '../Actions/OrderArticleForm.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    payload: {
        orderArticleFormDetails: {}
    },
    errors: {},
    result: {},
    isSubmitting: false,
};

export const orderArticleForm = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ORDER_ARTICLE_FORM_SET_ORDER_ARTICLE_FORM_DETAILS:
        case ORDER_ARTICLE_FORM_SET_FILE_NAMES:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    [payload.key]: {
                        ...state.payload[payload.key],
                        ...payload.data
                    }
                }
            };
        case ORDER_ARTICLE_FORM_SUBMIT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            };
        case ORDER_ARTICLE_FORM_SUBMIT:
        case ORDER_ARTICLE_FORM_SUBMIT_DONE:
            return {
                ...state,
                ...payload
            };
        default:
            return state;
    }
};
